import React from "react";
import { Control, FieldValues, useController } from "react-hook-form";
import useFetchChoices from "../../choices/useFetchChoices";
import { Dropdown } from "./Dropdown";
import { dropdownItemsType, dropdownItemType } from "../../types/common";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface DropdownFieldProps<T extends FieldValues> {
	additionalClasses?: string;
	choicesEndpoint?: string;
	control: Control<T>;
	defaultValue?: object;
	dropdownToggle?: string;
	dropdownItems?: dropdownItemsType;
	label: string;
	onFieldChange?: (name: string, choice: dropdownItemType) => any;
	name: string;
	preselected?: boolean;
	required?: boolean;
}

export function DropdownField({
	additionalClasses,
	choicesEndpoint,
	control,
	defaultValue,
	dropdownItems,
	dropdownToggle,
	label,
	onFieldChange,
	name,
	preselected = false,
	required = false,
}: DropdownFieldProps<any>) {
	const {
		choices,
		loading,
		error: loadingError,
	} = useFetchChoices(
		`/api/v1/choices/${choicesEndpoint}`,
		undefined,
		!dropdownItems,
	);

	const {
		field: { value, onChange },
		fieldState: { error },
	} = useController({
		name,
		control,
		rules: {
			required,
		},
		defaultValue,
	});

	const handleDropdownItemClick = (choice: dropdownItemType) => {
		onFieldChange && onFieldChange(name, choice);
		onChange(choice);
	};

	return (
		<Dropdown
			additionalClasses={additionalClasses}
			dropdownItems={
				dropdownItems || (!loading && !loadingError ? choices : [])
			}
			dropdownToggle={
				value ? value?.value : loading ? "Loading..." : dropdownToggle
			}
			error={error}
			label={label}
			onDropdownItemClick={handleDropdownItemClick}
			required
			preselected={preselected || !!value?.value}
		/>
	);
}
